import React, { useEffect, useState } from "react";
import { Table, Typography, Button, Space, Popconfirm, message } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const { Title } = Typography;

function ManageClients() {
  const [clients, setClients] = useState([]);
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("access-token");

  // Fetch clients
  useEffect(() => {
    const fetchClients = async () => {
      try {
        const res = await axios.get("https://rhrmapi.up2dateinc.com/api/clients", {
          headers: { Authorization: `Bearer ${accessToken}` }
        });

        // Make sure it's always an array
        setClients(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error("Failed to fetch clients:", err);
        setClients([]);
        message.error("Failed to load clients");
      }
    };

    fetchClients();
  }, [accessToken]);

  // Delete client
  const deleteClient = async (id) => {
    try {
      await axios.delete(`https://rhrmapi.up2dateinc.com/api/clients/${id}`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });

      setClients(clients.filter((client) => client._id !== id));
      message.success("Client deleted successfully");
    } catch (err) {
      console.error("Failed to delete client:", err);
      message.error("Failed to delete client");
    }
  };

  const columns = [
    { title: "SL No", render: (_, __, index) => index + 1 },
    { title: "Client Name", dataIndex: "name" },
    { title: "Company", dataIndex: "company" },
    { title: "Email Address", dataIndex: "email" },
    { title: "Country", dataIndex: "country" },
    {
      title: "Action",
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => navigate(`/admin/update-client/${record._id}`)}
          >
            Edit
          </Button>

          <Popconfirm
          title="Delete this project?"
          disabled
          onClick={() => message.info("Delete disabled. Requires admin approval")}
          
          >
          <Button type="link" danger>
          Delete
          </Button>
          </Popconfirm>
          
        </Space>
      )
    }
  ];

  return (
    <div>
      <Title level={3}>Manage Clients</Title>

      <Table
        rowKey="_id"
        columns={columns}
        dataSource={Array.isArray(clients) ? clients : []} // ✅ ensures array
        pagination={{ pageSize: 5 }}
      />
    </div>
  );
}

export default ManageClients;